import { useEffect, useState } from 'react';
import { Lock } from '../../lib/icons';
import { indexEmissions } from '../../lib/facturable';

// Reconnaissance d'une opération déjà facturée, affichable depuis tous les écrans.
export const BadgeFacture = ({ type, id }) => {
  const [emission, setEmission] = useState(null);

  useEffect(() => {
    let vivant = true;
    indexEmissions().then((index) => {
      if (vivant) setEmission(index.get(`${type}:${id}`) ?? null);
    });
    return () => {
      vivant = false;
    };
  }, [type, id]);

  if (!emission) return null;
  return (
    <span
      data-testid={`badge-facture-${id}`}
      title={`Facture officielle ${emission.numero} figée le ${String(emission.emis_le).slice(0, 10)}`}
      className={`ml-1 inline-flex items-center gap-1 px-1.5 py-0.5 font-data text-[10px] uppercase tracking-[0.08em] ${
        emission.annulee_par ? 'bg-slate-200 text-slate-700' : 'bg-emerald-50 text-emerald-800'
      }`}
    >
      <Lock size={10} /> {emission.numero}
    </span>
  );
};
